var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useRef, useState } from 'react';
import { UXPContext } from '@core/context/Context';
import { SlideInPanel } from '@widget/other/SlideInPanel';
import Button from '@widget/buttons/Button';
import AsyncButton from '@widget/buttons/AsyncButton';
export const PipelineRefineModal = ({ show, pipeline, onClose, onApply }) => {
    const context = useContext(UXPContext);
    const [QueryBuilder, setQueryBuilder] = useState(null);
    const [applyError, setApplyError] = useState(null);
    const queryBuilderRef = useRef(null);
    useEffect(() => {
        if (!show)
            return;
        setApplyError(null);
        setQueryBuilder(() => { var _a, _b; return (_b = (_a = window.QueryBuilderComponents) === null || _a === void 0 ? void 0 : _a.QueryBuilder) !== null && _b !== void 0 ? _b : null; });
    }, [show]);
    function handleApply() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            setApplyError(null);
            try {
                const result = yield ((_a = queryBuilderRef.current) === null || _a === void 0 ? void 0 : _a.onSave());
                if (!(result === null || result === void 0 ? void 0 : result.isValid) || !(result === null || result === void 0 ? void 0 : result.query)) {
                    setApplyError((result === null || result === void 0 ? void 0 : result.error) || context.$L('uxp-core.text.advanced-filter-no-results'));
                    return;
                }
                onApply(result.query);
                onClose();
            }
            catch (e) {
                setApplyError(context.$L('uxp-core.text.advanced-filter-no-results'));
            }
        });
    }
    const isReady = !!QueryBuilder && !!pipeline;
    return (_jsx(SlideInPanel, { isOpen: show, onClose: onClose, direction: 'right', children: _jsxs("div", { className: "uxpcore_osc__refine_panel", children: [_jsxs("div", { className: "uxpcore_osc__refine_panel__header", children: [_jsx("span", { className: "uxpcore_osc__refine_panel__title", children: context.$L('uxp-core.text.refine-pipeline') }), _jsxs("div", { className: "uxpcore_osc__refine_panel__header-actions", children: [_jsx(Button, { title: context.$L('uxp-core.text.cancel'), onClick: onClose, variant: 'secondary', size: 'small' }), _jsx(AsyncButton, { title: context.$L('uxp-core.text.apply-changes'), loadingTitle: context.$L('uxp-core.text.applying'), onClick: handleApply, variant: 'primary', disabled: !isReady })] })] }), applyError && (_jsx("div", { className: "uxpcore_osc__refine_panel__error", children: applyError })), _jsxs("div", { className: "uxpcore_osc__refine_panel__body", children: [!QueryBuilder && (_jsx("div", { className: "uxpcore_osc__refine_panel__unavailable", children: context.$L('uxp-core.text.query-builder-unavailable') })), QueryBuilder && pipeline && (_jsx(QueryBuilder, { initialQuery: pipeline, uxpContext: context, ref: queryBuilderRef }))] })] }) }));
};
